import { SystemDateSaveFormat } from 'app/modules/core'
import moment from 'moment'

interface ISelectMonthProps extends React.HTMLAttributes<HTMLSelectElement | HTMLInputElement> {
    startMonth: Date
    endMonth: Date
    value?: Date
    className?: string
    handleChange?: (e: any) => void
    disabled?: boolean
    defaultValue?:string
}

export const SelectMonth: React.FC<ISelectMonthProps> = (props) => {

    const opt: any[] = []
    const runningMonth = props.startMonth
    const endLoopDate = props.endMonth
    let cnt = 0;
    while (runningMonth < endLoopDate) {
        opt.push(<option key={cnt}
            value={moment(runningMonth).format("YYYY-MM-01")}
        >{moment(runningMonth).format("YYYY MMM")}</option>)
        runningMonth.setMonth(runningMonth.getMonth() + 1)
        cnt++
    }
    return (
        <>
            <select className='form-control select' onChange={props.handleChange}
                defaultValue={props.defaultValue}
                value={moment(props.value).format("YYYY-MM-01")}
                disabled={props.disabled}>
                {opt}
            </select>
        </>
    )
}
